import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { UserAuthContextProvider2 } from "./contextApi/backlink/useAuthContext";
import { ROUTES2 } from "./routes/Routes2";
import LimitState from "./contextApi/backlink/LimitState";
import BacklinkLogin from "./Backlink/src/Login/Login";
import PublicDashBoard from "./Backlink/src/PublicDashBoard/PublicDashBoard";
import Landing from "./Backlink/src/Landing/Landing";
import ErrorPage from "./Components/ErrorPage/ErrorPage";
import ErrorLogsDialog from "./Components/ErrorLogger/ErrorLogger";
import AuthenticationIndexMeNow from "./Backlink/src/IndexMeNow/AuthenticationIndexMeNow";

const Backlink = ({ children }) => {
  return (
    <UserAuthContextProvider2>
      <LimitState>
        <ErrorLogsDialog />
        {children}
        <Router>
          <Routes>
            <Route
              path="/backlink"
              element={<Navigate replace to="/backlink/link" />}
            />
            <Route path="/backlink/login" element={<BacklinkLogin />} />
            <Route
              path="/backlink/public/:list_name/:list_id"
              element={<PublicDashBoard />}
            />
            <Route
              path="/backlink/auth-index-me-now"
              element={<AuthenticationIndexMeNow />}
              exact
            />
            <Route path="/backlink" element={<Landing />}>
              {ROUTES2.map((routes) => {
                return (
                  <Route
                    exact
                    path={routes.path}
                    element={routes.component}
                    key={routes.name}
                  />
                );
              })}
            </Route>
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Router>
      </LimitState>
    </UserAuthContextProvider2>
  );
};

export default Backlink;
